// WebSocket hook: subscribes to a department channel (0 = global for admin/manager).
import { useEffect, useRef } from "react";

export function useTaskSocket(deptId, onEvent) {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (deptId === null || deptId === undefined) return;
    const token = localStorage.getItem("tf_token");
    if (!token) return;

    const proto = location.protocol === "https:" ? "wss" : "ws";
    const url = `${proto}://${location.host}/ws/${deptId}?token=${token}`;
    let ws;
    let closedByUs = false;
    let retry;

    const connect = () => {
      ws = new WebSocket(url);
      ws.onmessage = (e) => {
        try {
          cbRef.current?.(JSON.parse(e.data));
        } catch { /* ignore */ }
      };
      ws.onclose = () => {
        if (!closedByUs) retry = setTimeout(connect, 3000);
      };
    };
    connect();

    return () => {
      closedByUs = true;
      clearTimeout(retry);
      ws?.close();
    };
  }, [deptId]);
}
